// extracted by mini-css-extract-plugin
export default {"filtersWrapper":"styles_filtersWrapper__jFR6-","searchButton":"styles_searchButton__u47pM","input":"styles_input__4Tkeo","tableWrapper":"styles_tableWrapper__tAtbA"};